<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div @click="showDropdowns" class="noselect wy-header-menu-filtering interactions" v-bind:class="{'selected': isSelected}" v-if="enableFilter">
    <el-dropdown 
      class="wy-header-manu-dropdown"
      ref="filterWidget" 
      :hide-on-click="false" 
      placement="top-start"
      trigger="click"
      @visible-change="handleChangeVisible">
      <span class="el-dropdown-title wy-disable-select">
        
        <div class="header-title">Organization</div>
        <div class="el-dropdown-subtitle">{{subTitle}}</div>
        <i v-bind:class="{'el-icon-caret-right':!isSelected, 'angle-up':isSelected }" ></i>
        <!-- <div v-if="moreFiltersCounter > 0" class="el-dropdown-subtitle">
        ({{moreFiltersCounter}})
        </div>
        <div v-else class="el-dropdown-subtitle">
        </div> -->
        
      </span>
      <el-dropdown-menu class="wy-header-menu-panel wy-header-menu-filtering-panel-interactions" ref="interactionPopup" :class="{'has-brand': showBrands, 'no-date-range-layout': isDateRageHidden}">
          <div class="menu-panel" v-if="isShow">
            <div class="filtering-panel" v-if="isShow"> 
              <table class="table-content">
                <tr>
                  <td>
                    <div class="dropdown-group">  
                      <div class="filter-section mutiple-select-section agent-groups">
                        <wy-filter-item-multi-select ref="agentGroupsDropdown" 
                          v-if="dataModel.filters.agentGroups" :filter="dataModel.filters.agentGroups" :dataSource="agentGroupsComponentDataSource" :dropdownDisabled="agentGroupsDisabled" 
                          :filterChangedCallback="agentGroupsChangedCallback" />
                      </div> 

                      <div class="filter-section mutiple-select-section agent-teams">
                        <wy-filter-item-multi-select ref="agentTeamsDropdown" 
                        v-if="dataModel.filters.agentTeams" :filter="dataModel.filters.agentTeams" :dataSource="agentTeamsComponentDataSource" :dropdownDisabled = "agentTeamsDisabled" 
                        :filterChangedCallback="agentTeamsChangedCallback" />
                      </div>                    
                      
                      <div class="filter-section mutiple-select-section agents">
                        <wy-filter-item-multi-select ref="agentsDropdown" 
                        v-if="dataModel.filters.agents" :filter="dataModel.filters.agents" :dataSource="agentsComponentDataSource" :dropdownDisabled = "agentsDisabled" 
                        :filterChangedCallback="agentsChangedCallback" />
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <!-- <hr class="divider-line" /> -->
          <div class="divider-line"></div>
          <a @click="closePopup()" class="cancel-btn prevent-select">Cancel</a>
          <a @click="clearAll()" class="clear-btn prevent-select">Reset all</a>
          <!-- <el-button plain class="clear-btn" @click="clearAll">Reset all</el-button> -->
          <el-button :disabled="!hasChanged" class="wy-white-button global-filters-apply" ref="globalFiltersApplyBtn" size="mini" @click="handleApply()">{{ $t('button.apply') }}</el-button> 
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import WyFilterItemMultiSelect from '../../widgets/wy-filters/wy-filter-item-multi-select'

export default {
  name: 'wy-header-menu-filtering-interactions',
  components: { 
    'wy-filter-item-multi-select': WyFilterItemMultiSelect,
  },
  data() {
    return {
      controller: module,
      subTitle: 'All',
      isShow: false,
      isSelected: false,
      filterError: {
        hasError: false
      },
      disabledTempObject: {},
      agentGroupsDisabled: false,
      agentTeamsDisabled: false,
      agentsDisabled: false,
      agentTeamsDataSource: null,
      agentGroupsDataSource: null,
      agentsDataSource: null,
      businessHourMapping: {duringBusinessHours: 'During business hours', outsideBusinessHours: 'Outside business hours'},
      businessHoursList: ['duringBusinessHours', 'outsideBusinessHours'],
      businessHoursModel: ['duringBusinessHours', 'outsideBusinessHours']
    };
  },

  watch: {
    'dataModel.dateStart': {
      immediate: false,
      handler() {
        if(this.$refs.filterWidget) {
          this.$refs.filterWidget.triggerElmFocus = function() {};
        }        
      }
    }
  },

  computed: {
    ...mapGetters(['dataModel', "authUser", 'localStorage', 'moreFiltersCounter', 'changedFilters', 'filterChangedStatus']),
    isDateRageHidden() {
      let widget = this.$route.meta.headerMenuItems.find(el=>{
        return el.name == 'date-widget'
      })
      let isHidden = false;
      if((widget && widget.properties.hidden) || widget == undefined) {
        isHidden = true
      }
      return isHidden;
    },

    enableFilter() {
      let hasChanaged = this.$store.state.site.changed;
      if(hasChanaged) {
        return this.dataModel.hasFilter;
      }
      else {
        return false;
      }
    },

    showBrands() {
      return this.authUser && this.authUser.companyList && this.authUser.companyList.length > 1;
    },

    hasChanged() {
      let isChanged = false;
      for(const filterName in this.dataModel.filters) {
        this.checkFilterChanged(this.dataModel.filters[filterName])
        if(!this.filterChangedStatus) {
          isChanged = true;
        }
      }
      return isChanged;
    }
  },

  methods: {
    ...mapActions(['applyFilterValue', 'undoFilterValue', 'resetFilterValue', 'checkFilterChanged']),

    prepareContent() {
      let agentGroupsComponent = this.$refs.agentGroupsDropdown;
      let agentTeamsComponent = this.$refs.agentTeamsDropdown;
      let agentsComponent = this.$refs.agentsDropdown;

      this.subTitle = '';
      if(agentGroupsComponent && agentGroupsComponent.filter) {
        this.getContent(agentGroupsComponent.filter.value, agentGroupsComponent.localDataSource, false, 'groups')
      }
      if(agentTeamsComponent && agentTeamsComponent.filter) {
        this.getContent(agentTeamsComponent.filter.value, agentTeamsComponent.localDataSource, false, 'teams')
      }
      if(agentsComponent && agentsComponent.filter) {
        this.getContent(agentsComponent.filter.value, agentsComponent.localDataSource, false, 'agents')
      }
      if(this.subTitle == 'All, All, All' || this.subTitle == 'All, All') {
        this.subTitle = 'All';
      }
    },

    getContent(list, source, showAll, from) {
      if(list.length == 0 || list.includes('all')) {
        if(this.subTitle == ''){
          this.subTitle = 'All';
        }
        else {
          if(from == 'teams' && this.$refs.agentsDropdown.filter.value.length > 0) {
            this.subTitle = this.subTitle + ', All';
          }
          else {
            this.subTitle = this.subTitle;
          }
        }
      }
      else {
        if(showAll) {
          source.filter((item) => {
            if(list.includes(item.key)) {
              if(this.subTitle == ''){
                this.subTitle = item.label;
              }
              else {
                this.subTitle = this.subTitle + ', ' + item.label;
              }
            }
          })
        }
        else {
          source.forEach((item) => {
            if(list[0] ==item.key) {
              if(list.length == 1) {
                if(this.subTitle == ''){
                  this.subTitle = item.label;
                }
                else {
                  this.subTitle = this.subTitle + ', ' + item.label;
                }
              }
              else {
                if(this.subTitle == ''){
                  this.subTitle = item.label + " +" + (list.length - 1);
                }
                else {
                  this.subTitle = this.subTitle + ', ' + item.label + " +" + (list.length - 1);
                }
              }
            }
          })
        }
      }
      return this.subTitle;
    },

    agentGroupsChangedCallback() {      
      let agentGroupsComponent = this.$refs.agentGroupsDropdown;
      let agentTeamsComponent = this.$refs.agentTeamsDropdown;
      let agentsComponent = this.$refs.agentsDropdown;

      let filterGroups = agentGroupsComponent.preSelectedFilters
      if(filterGroups.length == 0) {
        filterGroups = [];
        this.agentGroupsDataSource.forEach(el => {
          filterGroups.push(el.key)
        })
      }
      if(filterGroups.includes("all")) {
        filterGroups = [];
        this.agentGroupsDataSource.forEach(el => {
          filterGroups.push(el.key)
        })
      }
      agentTeamsComponent.localDataSource = [];
      agentsComponent.localDataSource = [];
      let selectedAgentTeams = this.agentTeamsDataSource.filter(team => filterGroups.includes(team.groupId));
      if(selectedAgentTeams.length > 0) {
        agentTeamsComponent.localDataSource.push(this.agentTeamsDataSource[0]);
        agentTeamsComponent.localDataSource = agentTeamsComponent.localDataSource.concat(selectedAgentTeams);
      }
      agentTeamsComponent.cloneLocalDataSource = agentTeamsComponent.localDataSource;
      this.agentTeamsComponentDataSource = agentTeamsComponent.localDataSource;
      const teamKeys = agentTeamsComponent.localDataSource.map(team => team.key)

      let selectedAgents =  this.agentsDataSource.filter(agent => teamKeys.includes(agent.teamId));
      if(selectedAgents.length > 0) {
        agentsComponent.localDataSource.push(this.agentsDataSource[0]);
      }
      agentsComponent.localDataSource = agentsComponent.localDataSource.concat(selectedAgents);
      agentsComponent.cloneLocalDataSource = agentsComponent.localDataSource;
      this.agentsComponentDataSource = agentsComponent.localDataSource;
      this.prepareContent();
    },

    agentTeamsChangedCallback() {
      let agentTeamsComponent = this.$refs.agentTeamsDropdown;
      let agentsComponent = this.$refs.agentsDropdown;
      agentsComponent.localDataSource = [];
      let filterTeams = agentTeamsComponent.preSelectedFilters
      
      if(filterTeams.length == 0) {
        filterTeams = [];
        this.agentTeamsDataSource.forEach(el => {
          filterTeams.push(el.key)
        })
      }
      if(filterTeams.includes("all")) {
        filterTeams = [];
        if(agentTeamsComponent.localDataSource.length > 1) {
          agentTeamsComponent.localDataSource.forEach((el, index) => {
            if(index > 0) {
              filterTeams.push(el.key)
            }
          })
        }
      }
      // const teamKeys = agentTeamsComponent.localDataSource.map(team => team.key)
      let selectedAgents =  this.agentsDataSource.filter(agent => filterTeams.includes(agent.teamId));
      // let selectedAgents =  this.agentsDataSource.filter(agent => agentTeamsComponent.localDataSource.filter(team => (filterTeams.includes(team.key))).some(team => team.key == agent.teamId))
      if(selectedAgents.length > 0) {
        agentsComponent.localDataSource.push(this.agentsDataSource[0]);
      }
      
      agentsComponent.localDataSource = agentsComponent.localDataSource.concat(selectedAgents);
      agentsComponent.cloneLocalDataSource = agentsComponent.localDataSource;
      this.agentsComponentDataSource = agentsComponent.localDataSource;
      if(agentTeamsComponent && agentTeamsComponent.filter.value.length > 0) {
        this.agentGroupsDisabled = true;
      }
      else {
        this.agentGroupsDisabled = false;
      }
      this.prepareContent();
    },

    agentsChangedCallback() {
      let agentTeamsComponent = this.$refs.agentTeamsDropdown;
      let agentsComponent = this.$refs.agentsDropdown;
      if(agentsComponent && agentsComponent.filter.value.length > 0) {
        this.agentGroupsDisabled = true;
        this.agentTeamsDisabled = true;
      }
      else {
        this.agentTeamsDisabled = false;
        if(agentTeamsComponent && agentTeamsComponent.filter.value.length > 0) {
          this.agentGroupsDisabled = true;
        }
        else {
          this.agentGroupsDisabled = false;
        }
      }
      this.prepareContent();
    },

    handleChangeVisible(isOpen) {
      if(isOpen) {
        // setTimeout(() => {
        //   let clickSourceEl = document.querySelector('.wy-header-menu-filtering.interactions')
        //   let el = document.querySelector('.wy-header-menu-filtering-panel-interactions')
        //   el.setAttribute('style', `left: ${clickSourceEl.getBoundingClientRect().left + 2}px !important; transition-delay: 0s; position: absolute; transform-origin: center top; z-index: 2001;`);  
        // }, 0);
        
        if(this.$refs.filterWidget) {
          this.dataModel.filters.agentGroups.isDropdownDisabled = false;
          this.dataModel.filters.agentTeams.isDropdownDisabled = false;
          this.dataModel.filters.agents.isDropdownDisabled = false;

          if(this.dataModel.filters.agentTeams && !this.agentsDataSource) {

            this.agentGroupsDataSource = JSON.parse(JSON.stringify(this.dataModel.filters.agentGroups.dataSource));
            this.agentGroupsComponentDataSource = JSON.parse(JSON.stringify(this.dataModel.filters.agentGroups.dataSource));
            this.dataModel.filters.agentGroups.isEmpty = (this.agentGroupsDataSource.length == 1 && this.agentGroupsDataSource[0].key == 'all');

            this.agentTeamsDataSource = JSON.parse(JSON.stringify(this.dataModel.filters.agentTeams.dataSource));
            this.agentTeamsComponentDataSource = JSON.parse(JSON.stringify(this.dataModel.filters.agentTeams.dataSource));
            this.dataModel.filters.agentTeams.isEmpty = (this.agentTeamsDataSource.length == 1 && this.agentTeamsDataSource[0].key == 'all');

            this.agentsDataSource = JSON.parse(JSON.stringify(this.dataModel.filters.agents.dataSource));
            this.agentsComponentDataSource = JSON.parse(JSON.stringify(this.dataModel.filters.agents.dataSource));
            this.dataModel.filters.agents.isEmpty = (this.agentsDataSource.length == 1 && this.agentsDataSource[0].key == 'all');
          }
          if(this.dataModel.filters && this.dataModel.filters.businessHoursType) {
            if(this.dataModel.filters.businessHoursType.value == 0) {
              this.businessHoursModel = ['duringBusinessHours', 'outsideBusinessHours']
            }
            else {
              if(this.dataModel.filters.businessHoursType.value) {
                this.businessHoursModel =  [this.businessHoursList[this.dataModel.filters.businessHoursType.value - 1]]
              }
            }
          }

          // remove queues are not assosiated with agents from ds
          this.$refs.filterWidget.show();
          this.$refs.filterWidget.popperElm.style.transitionDelay = "0s";
          this.isShow = true;
          this.isSelected = true;
          this.$refs.filterWidget.triggerElm.disabled = true;
        }
      }
      else {
        if(this.$refs.filterWidget) {
          this.$refs.filterWidget.triggerElm.disabled = false;      
          this.$refs.filterWidget.hide();
          this.$refs.filterWidget.popperElm.style.transitionDelay = "0.1s";
          this.isSelected = false;

          let agentTeamsComponent = this.$refs.agentTeamsDropdown;
          let agentsComponent = this.$refs.agentsDropdown;
          if(agentsComponent && agentsComponent.filter.value.length > 0) {
            this.agentGroupsDisabled = true;
            this.agentTeamsDisabled = true;
          }
          else {
            this.agentTeamsDisabled = false;
            if(agentTeamsComponent && agentTeamsComponent.filter.value.length > 0) {
              this.agentGroupsDisabled = true;
            }
            else {
              this.agentGroupsDisabled = false;
            }
          }
          this.prepareContent();
        }
      }
      // fire global click overlay event to show the modal
      this.$root.$emit(`fire-app-clickOverlayModal-events`, {handleApply: this.handleApply, active: isOpen});
    },

    async handleApply(){
      let isChanged = false;
      for(const filterName in this.dataModel.filters) {
        if(await this.applyFilterValue(this.dataModel.filters[filterName])) {
          isChanged = true;
        }
      }
      if(isChanged) {
        // fire event to trigger seaerch
        this.$root.fireEvent({name: 'handleFilterChange', type: 'Global Filter: More'});
      }

      if(this.$refs.agentsDropdown) this.$refs.agentsDropdown.closeDropdown();
      if(this.$refs.agentTeamsDropdown) this.$refs.agentTeamsDropdown.closeDropdown();
      if(this.$refs.agentGroupsDropdown) this.$refs.agentGroupsDropdown.closeDropdown();

      this.handleChangeVisible(false);
      
      this.dataModel.appliedFiltersCounter = this.moreFiltersCounter;
      this.dataModel.changedFilters = this.changedFilters;
    },
    
    showDropdowns(){
      setTimeout(() => {
        document.querySelectorAll('.el-select-dropdown__wrap').forEach(el => {
          el.style.display = "block";
        })
      }, 0);
    },

    clearAll(){
      this.agentGroupsDataSource.splice(0, this.agentGroupsDataSource.length);
      this.agentGroupsDataSource.push(...JSON.parse(JSON.stringify(this.dataModel.filters.agentGroups.dataSource)));
      this.dataModel.filters.agentGroups.isEmpty = (this.agentGroupsDataSource.length == 1 && this.agentGroupsDataSource[0].key == 'all');

      this.agentTeamsDataSource.splice(0, this.agentTeamsDataSource.length);
      this.agentTeamsDataSource.push(...JSON.parse(JSON.stringify(this.dataModel.filters.agentTeams.dataSource)));
      this.dataModel.filters.agentTeams.isEmpty = (this.agentTeamsDataSource.length == 1 && this.agentTeamsDataSource[0].key == 'all');

      this.agentsDataSource.splice(0, this.agentsDataSource.length);
      this.agentsDataSource.push(...JSON.parse(JSON.stringify(this.dataModel.filters.agents.dataSource)));
      this.dataModel.filters.agents.isEmpty = (this.agentsDataSource.length == 1 && this.agentsDataSource[0].key == 'all');

      this.dataModel.filters.agentGroups.value = [];
      this.dataModel.filters.agentTeams.value = [];
      this.dataModel.filters.agents.value = [];

      let agentGroupsComponent = this.$refs.agentGroupsDropdown;
      let agentTeamsComponent = this.$refs.agentTeamsDropdown;
      let agentsComponent = this.$refs.agentsDropdown;
      agentGroupsComponent.preSelectedFilters = [];
      agentTeamsComponent.preSelectedFilters = [];
      agentsComponent.preSelectedFilters = [];
      

      agentTeamsComponent.localDataSource = this.localStorage.agentData.agentTeams.dataSource
      agentsComponent.localDataSource = this.localStorage.agentData.agents.dataSource

      this.agentGroupsChangedCallback();
      this.agentTeamsChangedCallback();
      this.agentsChangedCallback();

      // this.disabledTempObject.agentGroupsDisabledTemp = this.agentGroupsDisabled;
      // this.disabledTempObject.agentTeamsDisabledTemp = this.agentTeamsDisabled;
      // this.disabledTempObject.agentsDisabledTemp = this.agentsDisabled;

      this.agentGroupsDisabled = false;
      this.agentTeamsDisabled = false;
      this.agentsDisabled = false;
    },

    closePopup() {
      let agentGroupsComponent = this.$refs.agentGroupsDropdown;
      let agentTeamsComponent = this.$refs.agentTeamsDropdown;
      let agentsComponent = this.$refs.agentsDropdown;
      this.undoFilterValue({names: this.dataModel.currFilterNames.filter(item => item != 'custTypes')});
      agentGroupsComponent.preSelectedFilters = this.dataModel.filters.agentGroups.value;
      agentTeamsComponent.preSelectedFilters = this.dataModel.filters.agentTeams.value;
      agentsComponent.preSelectedFilters = this.dataModel.filters.agents.value;
      this.agentGroupsChangedCallback();
      this.agentTeamsChangedCallback();
      this.agentsChangedCallback();
      this.handleChangeVisible(false);      
    },

    handleBusinessHourChange() {
      if(this.businessHoursModel.length == 2) {
        this.dataModel.filters.businessHoursType.value = 0;
      }
      else {
        this.businessHoursList.forEach((item, index)=>{
          if(item == this.businessHoursModel[0]) {
            this.dataModel.filters.businessHoursType.value = index + 1;
          }
        })
      }
    }
  },

  created() {
    // let first = this.dataModel.filters.agents.dataSource[0]
    // this.dataModel.filters.agents.dataSource = [];
    // this.dataModel.filters.agents.dataSource.push(first)
    // for(let i = 0; i < 1000; i++) {
    //   let obj = {
    //     "key": "",
    //     "label": "Team",
    //     "teamId": "4",
    //     "groupId": "3",
    //   }
    //   // let randomNum = Math.floor(Math.random() * 6).toString();
    //   obj.key = i.toString();
    //   obj.label = "Team3 " + '--' + i,
    //   // obj.label = "Team " + randomNum + '--' + i,
    //   // obj.teamId = randomNum;
    //   this.dataModel.filters.agents.dataSource.push(obj)
    // }
    // let obj1 = {
    //     "key": (this.dataModel.filters.agents.dataSource.length).toString(),
    //     "label": "Team",
    //     "teamId": "5",
    //     "groupId": "3",
    //   }
    // this.dataModel.filters.agents.dataSource.push(obj1)
    // console.log(this.dataModel.filters.agents.dataSource)
  },
  
  mounted() {
    if(!this.dataModel.dateStart) {
      document.querySelector(".component.interactions-filtering-widget").style.display = 'none';
    }
    else {
      document.querySelector(".component.interactions-filtering-widget").style.display = 'inline-block';
    }
    if(this.$router.history.current.params.filterDisplayName) {
      this.subTitle = this.$router.history.current.params.filterDisplayName
    }
  },

  updated() {
    if(document.querySelector(".component.interactions-filtering-widget")) {
      if(!this.dataModel.dateStart) {
        document.querySelector(".component.interactions-filtering-widget").style.display = 'none';
      }
      else {
        document.querySelector(".component.interactions-filtering-widget").style.display = 'inline-block';
      }
    }
  },

  beforeDestroy() {
    this.handleChangeVisible(false);
  }
}
</script>

<style lang="scss">

.wy-header-menu-filtering-panel-ca.no-date-range-layout { 
  // left: 781px !important;
  left: var(--site-top-menu-filtering-panel-left-2310px) !important;
}
.wy-header-menu-filtering-panel-ca.has-brand {
  left: var(--site-top-menu-filtering-panel-left-show-brand) !important;
}
.wy-header-menu-filtering-panel-interactions {
  // min-width: 350px !important;
  // height: calc(100vh - 30px) !important;
  // max-height: 630px;
  width: min-content;
  border-radius: 0px;
  // width: 2099px;
  // left: 814px!important;
  margin: 64px 0px 0px 0px !important;
  // overflow-y: auto;
  // max-height: 500px;
  border-radius: 0px !important;
  // left: calc(100vw - 1181px) !important;
  // left: var(--site-top-menu-filtering-panel-left-interactions) !important;
  // left: unset !important;
  // right: 20px !important;
  .wy-header-menu-panel{
    height: 723px !important;
  }
  .el-scrollbar__wrap {
    background: #0F1A20 !important;
  }
  .vue__time-picker .dropdown .select-list {
  position: relative;
  top: 10px;
  width: 10em;
  height: 12em;
  border-radius: 5px;
  }
  .el-tag.el-tag--info {
    background: var(--top-menu-panel-filters-dropdown-tag-background-color);
    border: none;
    color: var(--nav-top-primary-color);
    // padding:5px 10px 5px 10px !important;
    padding: 1px 10px 1px 10px !important;
    font-size: 14px;
    // max-width: 800px!important;
    max-width: 49px !important;
    width: 146px;
    // height: 34px;
    height: 24px;
    top: 0px;
    position: relative;
    z-index: -1;
    margin-left: 1px;
  }
  .el-tag.el-tag--info:first-child {
    max-width: 146px !important;
    left: 5px;
  }
  // .el-tag.el-tag--info:last-child {
  //   max-width: 49px !important;
  // }
  .dropdown-group{
    position: relative;
    left: 30px;
  }
  
  .vue__time-picker .dropdown .hint {
      padding-top: 0px;
      padding-bottom: 5px;
      line-height: 17px;
  }
  .vue__time-picker .dropdown {
    position: absolute;
    z-index: 5;
    top: calc(2.2em + 8px);
    left: 0;
    background: #020E14;
    box-shadow: 0 1px 6px rgba(0,0,0,0.15);
    width: 10em;
    height: 10em;
    font-weight: normal;
  }
  span.char.times-icon {
      display: none !important;
  }
  .vue__time-picker .controls .char {
    display: inline;
  }
  .el-select-dropdown.el-popper.is-multiple.global-filter-picker-multiple-popper {
    top: 294px !important;
  }
  .el-select-dropdown {
    border: none !important;
  }
  .divider-line {
    position: relative;
    top: -80px;
    padding: 0px;
    margin: 0px;
    border-top: thin solid var(--site-interaction-top-menu-dropdown-border-color);
  }
  .cancel-btn{
    position: relative;
    bottom: 54px;
    left: 23px;
    font-size: 14px;
    color: var(--top-menu-panel-global-filter-cancel-btn-color);
    cursor: pointer;
  }
  .vue__time-picker .dropdown ul li {
    padding: 0em 0;
  }
  .clear-btn {
    position: relative;
    bottom: 54px;
    left: calc(100% - 253px);
    font-size: 14px;
    color: var(--top-menu-panel-global-filter-cancel-btn-color);
    cursor: pointer;
    &:hover{
      text-decoration: underline;
    }
  }
  
  .el-button {
    font-size: 14px !important;
    padding: 10px;
    font-weight: 400;
    background: #020E14;
    color: rgb(255, 255, 255)!important;
  }

  .el-checkbox__inner {
    top: 2px !important;
    width: 12px !important;
    height: 12px !important;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: var(--top-menu-panel-global-filter-header-text-color);
  }
  .filtering-panel {
    //height: calc(100vh - 60px);
    // max-height: 597px;
    // overflow-y: auto;
    max-height: calc(100vh - 144px);
    overflow: hidden;
    display: inline-flex;
    padding-top: 5px;
    height: 363px;
    // height: 382px;
    width: 100%;
    padding-bottom: 2px;
    border-bottom: 1px var(--top-menu-panel-global-filter-divider-color) solid;
  }
  .menu-panel {
    // padding: 0px 0 8px 0;
    // margin-right: 15px;
    // background-color: #020E14;
    //height: inherit;
    //max-height: 622px;
    user-select: none; /* supported by Chrome and Opera */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    -webkit-box-shadow: var(--top-menu-panel-brand-global-filter-background-shadow) !important;
    box-shadow: var(--top-menu-panel-brand-global-filter-background-shadow);
    background: var(--nav-top-menu-panel-background-color) 0% 0% no-repeat padding-box;
    // padding-bottom: 10px;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    // width: 535px;
    width: 364px;
    position: relative;
    right: 0px;
    min-height: 300px;
    height: 368px;
    // height: 469px;
    // min-width: 1078px;
    margin-left: -1px;
    // border-top: 1px solid #C9D3DA;
    box-shadow: 0px 4px 10px rgba(74, 74, 74, 0.25);
    border-radius: 0px 0px 5px 5px;
  }
  // @media (max-width: 1854px){
  // .wy-header-menu-filtering-panel-ca.no-date-range-layout 
  //   .menu-panel {
  //     right: 396px
  //   }
  // }
  // @media (max-width: 1854px){
  // .menu-panel {
  //     left: 2px !important;
  //   }
  // }

  .wy-white-button.global-filters-apply {
    width: 104px;
    height: 30px;
    border-radius: 10px;
    border: 1px white solid;
    left: calc(100% - 236px);
    top: -56px;
    background-color: var(--top-menu-panel-global-filter-primary-btn-background-color) !important;
    box-shadow: var(--top-menu-panel-global-filter-primary-btn-box-shadow) !important;
    padding-top: 6px;
    font-size: 14px;
    background: #020E14;
    border: 1px white solid;
    border-radius: 5px;
    color: var(--top-menu-panel-global-filter-primary-btn-text-color);
    font-size: 14px;
    align-content: center;
    font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
    position: relative;
    
    &:hover{
      border: 1px var(--top-menu-panel-global-filter-primary-btn-hover-border-color) solid !important;
      background-color: var(--top-menu-panel-global-filter-primary-btn-hover-background-color) !important;
      border-radius: 5px;
      color: var(--top-menu-panel-global-filter-primary-btn-hover-text-color) !important;
      font-size: 14px;
      align-content: center;
      font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
    }
    &:active {
      background-color: var(--top-menu-panel-global-filter-primary-btn-pressed-background-color) !important;
    }
    &:focus {
      border: 1px var(--top-menu-panel-global-filter-primary-btn-hover-border-color) solid !important;
      background-color: unset;
      border-radius: 5px;
      color: var(--top-menu-panel-global-filter-primary-btn-text-color) !important;
    }
    span {
      position: relative;
      top: 1px;
    }
  }

  > li.el-dropdown-menu__item {
    padding-bottom: 3px;
  }


  .filter-section.sources label.el-checkbox {
    padding-top: 8px;
    padding-bottom: 2px;
    padding-left: 14px;
    width: 216px;
    display: flex;
    align-content: center;
    flex-direction: row;
  }
  .filter-section.languages label.el-checkbox {
    margin-bottom: 19px;
    width: 224px;
  }
  .languages .el-checkbox__label, .sources .el-checkbox__label {
    font-weight: 500;
    line-height: 15px;
    white-space: pre-line;
  }
  .filter-section.avg-handling-time {
    padding-bottom: 3px;
    padding-left: 35px;
    position: relative;
    .vue__time-picker input.display-time {
      color: #FFF;
      &:focus-visible{
        outline: none !important;
      }
    }
    .vue__time-picker .dropdown ul li:not([disabled]).active{
      background: #1B262B !important;
    }
    .invalid-time-range {
      position: absolute;
      background: #F1D3D5;
      background-image: url("../../../assets/icons/icon_red_stop.svg");
      background-repeat: no-repeat;
      background-size: 14px;
      background-position-x: 10px; 
      background-position-y: center; 
      font-size: 13px;
      color: #59333E;
      border-radius: 5px;
      width: 245px;
      padding: 10px 0 10px 32px;
      line-height: 1;
      z-index: 1;
      top: 0px;
    }
  }
  .filter-section.business-hours {
    label.el-checkbox {
      padding-left: 10px !important;
      padding-bottom: 1px;
      padding-top: 7px;
    }
    .business-hours-title {
      font-size: 14px;
      display: block;
      color: #F4F6F8;
      font-weight: 600 !important;
      margin-bottom: 15px;
      margin-top: 9px;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label {
      cursor: not-allowed;
    }
    .el-checkbox__input.is-disabled .el-checkbox__inner {
      cursor: not-allowed;
    }
    .el-checkbox__input.is-disabled .el-checkbox__inner::after {
      cursor: not-allowed;
    }
  }
  .el-checkbox.is-disabled {
    cursor: not-allowed;
    .el-checkbox__input {
      pointer-events: none;
    }
    .el-checkbox__label {
      pointer-events: none;
    }
  }
  .el-input__inner{
    border: 0px;
  }
  ::placeholder {
    color: var(--nav-top-placeholder-color) !important;;
    opacity: 1; /* Firefox */
  }
  .el-select {
    display: block;
    border-radius: 10px;
    // border: 1px solid #DCDFE6;
    padding: 0px 5px 0px 0px;

    .el-select-dropdown {
      margin-top: 6px !important;
      left: 0px !important;
      min-width: 211px !important;

      .el-select-dropdown__wrap {
        max-height: 260px !important;
      }
    }
  }
  .el-date-editor--daterange {
    width: 260px !important;
  }
  .el-select-dropdown.el-popper.is-multiple {
    width: 210px;
  }
  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
    color: #214586;
  }
  .el-select-dropdown.el-popper {
    width: 210px;
  }
  .el-select__tags {
    .el-select__tags-text {
      word-break: break-word;
    }
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #F6F7F8;
  }
  .wy-filter-integer {
    .el-input-number--mini {
      width: 100px;
      line-height: 26px;
    }
    table {
      color: var(--site-font-primary-color);
      td:first-child {
        padding-left: 0px;
      }
      td {
        padding-left: 15px;
      }
    }
  }
  
  .wy-filter-integerRange {
    table {
      td:first-child {
        padding-left: 0px;
      }
      td {
        padding-left: 15px;
        color: #000000;
      }
    }
    .el-input.el-input--mini::after {
      content: "min";
      position: absolute;
      left: 45px;
      font-size: 10px;
    }
    .el-input-number--mini {
      width: 100px;
      input {
        padding-left: 0px;
        text-align: right;
        padding-right: 60px;
      }
    }
  }

  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
    // background-color: #020E14 !important;
    background-color: transparent !important;
    color: #F4F6F8;
  }
  .el-select .el-input.is-focus .el-input__inner {
      border-color: #C0C4CC;
      // height: 28px !important;
  }
  .el-dropdown-menu__item{
    padding: 10px 14px 0 20px;
    cursor: unset;
  }
  .el-dropdown-menu__item:nth-child(3) {
    text-align: right;
  }
  .filter-section .el-dropdown-menu__item{
    width: 100%;
    display: inline-block;
    padding: 0px 0px 0px 0px;  
    margin-bottom: 0px;
  }
  .filter-section .el-dropdown-menu__item.checkbox-item {
    width: 88%;
  }
  .filter-section  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
    right: 12px;
  }
  .el-dropdown-menu__item i {
    margin-right: 0px;
  }

  span.filter-title {
    display: block;
    font-weight: var(--top-menu-panel-global-filter-header-text-font-weight);
    // font-size: var(--top-menu-panel-global-filter-header-text-font-size);
    font-size: 12px;
    color: var(--site-interaction-primary-font-color);
    margin-bottom: 2px;
    line-height: 20px !important;
  }
  .max-topics span.filter-title {
    position: relative;
    top: 17px;
    height: 10px;
  }
  .filter-title-clear-all{
    float: right;
    font-size: 14px;
    font-weight: 500;
    color: #FFF;
    margin-right: -6px;
    cursor: pointer;
    position: relative;
    top: 279px;
    width: 60px;
    min-width: 58px;
    height: fit-content;
    left: calc(100% - 1334px) !important;
  }
  .filter-title-clear{
    font-size: 14px;
    color: #214586;
    cursor: pointer;
  }

  .vue__time-picker,.vue__time-picker input.display-time {
    color: var(--site-font-primary-color);
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    background-color: #020E14;
    border-radius: 5px;
    width: 90px !important;
    height: 38px;
    -webkit-box-shadow: unset !important;
    box-shadow: none !important;
    outline: none !important;
  }
  .vue__time-picker .dropdown ul li {
    background-color: #0F1A20 !important;
    &:hover{
      background: #1B262B !important;
      color: white;
    }
  }
  .vue__time-picker .dropdown ul li:not(.hint):not([disabled]):hover{
    color: white !important;
  }
  .vue__time-picker .dropdown ul.hours::-webkit-scrollbar {
    width: 12px;
  }
  .vue__time-picker .dropdown ul.minutes::-webkit-scrollbar {
    width: 12px;
  }
  .vue__time-picker .dropdown ul.seconds::-webkit-scrollbar {
    width: 12px;
  }
  span.el-tag.el-tag--info.el-tag--small.el-tag--light {
    width: 101px;
  }
  .vue__time-picker .dropdown ul.hours::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #CCC; 
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 
  }

  .vue__time-picker .dropdown ul.hours::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
    background-color: rgba(2, 14, 20, 0.2);
  }
  .vue__time-picker .dropdown ul.minutes::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
    background-color: rgba(2, 14, 20, 0.2);
  }
  .vue__time-picker .dropdown ul.seconds::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
    background-color: rgba(2, 14, 20, 0.2);
  }
  
  .vue__time-picker .dropdown ul.hours::-webkit-scrollbar-thumb {
      -webkit-border-radius: 10px;
      border-radius: 10px;
      background: #CCC; 
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 
  }
  .vue__time-picker .dropdown ul.minutes::-webkit-scrollbar-thumb {
      -webkit-border-radius: 10px;
      border-radius: 10px;
      background: #CCC; 
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 
  }
  .vue__time-picker .dropdown ul.seconds::-webkit-scrollbar-thumb {
      -webkit-border-radius: 10px;
      border-radius: 10px;
      background: #CCC; 
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 
  }

  .vue__time-picker .dropdown ul li {
    color: #F4F6F8;
    background-color: #384c55;
  }
  .from-to-sign {
    padding: 0 15px;
    color: #FFF;
  }
  .display-top {
    color: var(--nav-top-primary-color);
    width: 80px;
    vertical-align: bottom !important;
    font-size: 14px;
    font-weight: 500;
    position: relative;
    bottom: 9px;
    padding-right: 5px;
  }
  .display-top-topics {
    color: var(--nav-top-primary-color);
    padding-left: 5px;
    width: 80px;
    vertical-align: bottom !important;
    font-size: 14px;
    font-weight: 500;
    position: relative;
    left: -10px;
    bottom: 9px;
  }
  input {
    color: var(--site-font-primary-color);
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  .el-select__input {
    // color: #FFF !important;
    // color: var(--site-font-primary-color) !important;
    color: var(--nav-top-primary-color) !important;
    // max-width: none !important;
    margin-left: 10px;
  }
  .el-input{
    width: 100% !important;
    overflow: hidden;
  }
  .el-checkbox-group {
    margin-bottom: -10px;
    margin-top: 0px;

    .el-checkbox {
      display: flex;
      height: 23px;
      color: var(--top-menu-panel-global-filter-header-text-color);
      margin-bottom: 20px;
      span.el-checkbox__inner {
        border-radius: 0px;
        background-color: var(--top-menu-panel-global-filter-checkbox-button-background-color);
        color: var(--top-menu-panel-global-filter-checkbox-button-check-color);
        border: 1px solid var(--top-menu-panel-global-filter-checkbox-button-border-color) !important;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: var(--top-menu-panel-global-filter-checkbox-text-selected-background-color);
      }
      .el-checkbox__inner::after {
        border: 1px solid var(--top-menu-panel-global-filter-checkbox-button-check-color);
        border-left: 0;
        border-top: 0;
        width: 2px !important;
        top: 0px;
        left: 4px;
      }
      span.el-checkbox__inner:hover {
        -webkit-box-shadow: unset;
        box-shadow: unset;
      }
    }
    .el-checkbox.BotOnlyEscalated {
      left: 29px;
      padding-bottom: 17px!important;
      padding-top: 12px !important;
      padding: 25px;
      width: 162px !important;
      border-radius: 5px;
      margin-bottom: 19px; 
    } 
    .el-checkbox.BotOnlyContained{
      left: 29px;
      border-radius: 5px;
      // padding-bottom: 18px!important;
      // padding-top: 12px !important;
      padding: 25px;
      width: 162px !important;
      margin-bottom: 20px;
    }
    .el-checkbox.BotToLC{
      padding-bottom: 17px !important;
    }
  }

  table.table-content {
    td {
      vertical-align: top;
      
      .mutiple-select-section .wy-filter-item-multi-select {
        // padding-bottom: 25px;
        padding-top: 18px;
        padding-bottom: 0px;
        .el-select{
          width: 298px;
        }
        .agent-groups.el-select {
          margin-top: 7px;
        }
        .devices.el-select {
          margin-top: 7px;
        }
        .el-select__tags {
          max-width: 168px;
          // height: 28px;
          .el-tag.el-tag--info {
            max-width: 108px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          // .el-input--suffix input.el-input__inner {
          //   height: 38px !important;
          // }
          .el-select__input {
            position: relative;
            top: 0px;
          }
        }
      }
      .mutiple-select-section.agent-queues {
        .el-tag__close {
            display: none;
          }
      }
      .mutiple-select-section.agent-ids {
        .el-tag__close {
            display: none;
          }
      }
      .mutiple-select-section.agents {
        .el-tag__close {
            display: none;
          }
      }
      .mutiple-select-section.agent-teams {
        .el-tag__close {
            display: none;
          }
      }
      .mutiple-select-section.agent-groups {
        .el-tag__close {
            display: none;
          }
      }
      .mutiple-select-section.devices {
        .el-tag__close {
            display: none;
          }
      }
      
      input.el-input__inner {
        // border: 1px solid var(--top-menu-panel-filters-dropdown-border-color) !important;
        border: 1px solid var(--site-interaction-top-menu-dropdown-border-color) !important;
        border-radius: 5px;
        padding-left: 10px;
        height: 38px !important;
        color: var(--nav-top-primary-color);
        // background-color: var(--nav-top-menu-panel-background-color);
        background-color: #FFF;
        height: 38px;
        font-size: 14px;
      }

      .max-topics {
        padding-left: 30px;
      
        .el-input-number.is-controls-right .el-input__inner {
          padding-left: 28px;
          padding-right: 28px;
        }
        .vue__time-picker.time-picker {
          width: 90px !important;
          user-select: none;
        }
      }
      .wy-filter-item-integer {
        .el-input-number--mini {
          width: 106px;
          line-height: 26px;
          position: relative;
          top: 5px;
        }
        .el-dropdown-menu__item {
          line-height: 30px;
          position: relative;
          bottom: 9px;
          i{
            transform: scale(0.9) !important;
            top: 6px;
            right: 5px;
            position: relative;
          }
        }
      }
      .el-input-number__decrease {
        border: 0px !important;
        border-radius: 0 0 4px;
        position: relative;
        left: 15px !important;
        top: 28px !important;
        background-color: transparent;
        .el-icon-arrow-down::before {
          content: var(--header-icon-grey-decrease);
        }
      }
      .el-input-number__increase {
        border: 0px !important;
        border-radius: 0 0 4px;
        position: relative;
        left: 61px !important;
        top: 28px !important;
        background-color: transparent;
        .el-icon-arrow-up::before {
          content: var(--header-icon-grey-increase);
        }
      }
    }
  }

  .date-filter-picker-panel {
    top: 17px !important;
    left: -330px !important;
    
    .popper__arrow {
      display: none;
    }
    .el-date-table td.prev-month {
      color: #B3B3B3;
      background-color: #F5F5F5;
    }
    .el-date-table th {
      background-color: #EBF4FD;
      color: #4C7CAE;
    }
    .el-date-table td.start-date span,
    .el-date-table td.end-date span {
      background-color: var(--site-font-primary-color) !important;
    }
    .el-date-table td.in-range div {
      background-color: #004A87 !important;
      color: white !important;
    }
  }
  .el-select .el-input .el-select__caret {
    transform: rotateZ(0deg);
  }
  .el-select__caret.el-input__icon.el-icon-arrow-up:before {
    content: var(--header-drop-down-arrow-down);
  }
  .el-select .el-input .el-select__caret.is-reverse:before {
    content: var(--header-drop-down-arrow-up);
  }
}

.wy-header-menu-filtering-panel-interactions.wy-header-menu-panel{
  height: 368px !important;
  width: 364px !important;
  // left: 612px !important;
}
.wy-header-menu-filtering.selected {
  background: var(--nav-top-background-color-selected) 0% 0% no-repeat padding-box !important;
  position: relative;
  z-index: 9999;
}
.wy-header-menu-filtering {
  height: 100%;
  .wy-header-manu-dropdown{
    margin: 0px 10px 0px 10px !important;
    padding: 14px 10px 0 10px !important;
    border-radius: 5px !important;
    opacity: 1 !important;
    height: 38px !important;
    top: 12px !important;

    .angle-up {
      background-image: var(--header-drop-down-arrow-up);
      background-repeat: no-repeat;
      background-color: transparent;
      border: none;
      padding: 0;
      bottom: 10px;
      position: relative;
      height: 31px;
      background-size: 10px;
      width: 12px;
      left: 17px;
      display: inline-block;
    }
    .el-icon-caret-right{
      bottom: 17px !important;
      left: 17px !important;
    }
  }
  .wy-header-manu-dropdown.el-dropdown:hover {
    background-color: none !important;
  }
}

//global css

.global-filter-picker-multiple-popper {
  min-width: 298px !important;
  width: 270px;
  background: var(--nav-top-menu-panel-background-color);
  border: none;
  .el-select-dropdown__wrap {
    max-height: 206px !important;
  }
  .el-popper .popper__arro::after  {
    display: none !important;
  }
  .el-select-dropdown__list {
    padding: 0px 0;
    .el-select-dropdown__item:hover {
      background-color: #353E43 !important;
    }

    .el-select-dropdown__item.selected {
      color: var(--site-font-drop-down-secondary-color);
      background-color: var(--top-menu-panel-filters-dropdown-item-selected-background-color) !important;
      border: none;
      font-weight: unset;
    }
    .el-select-dropdown__item {
      padding: 0 20px 0 12px;
      margin: 7px 0px;
      border-radius: 5px;
      color: var(--nav-top-primary-color) !important;
      &:hover{
        background: var(--top-menu-panel-filters-dropdown-item-hover-background-color) !important;
      }
    }
    .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    background-color: transparent;
    }
    .el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover {
    background-color: #1B262B !important;
    }
    .el-select-dropdown__item.selected::after {
      right: 10px;
      content: var(--header-icon-dropdown-black-check);
      top: 3px;
    }
    // .el-select-dropdown__item:hover {
    //   background-color: #E8E8E9;
    // }
  } 
}

// .el-select-dropdown.el-popper.is-multiple.global-filter-picker-multiple-popper.with-checkbox {
//   .el-select-dropdown__item.selected {
//     background-color: unset !important;
//   }
//   .el-select-dropdown__item:hover {
//     background: unset !important;
//   }
//   .el-select-dropdown__item.selected::after {
//     display: none !important;
//   }
//   .label-click {
//     cursor: pointer;
//     color: var(--site-interaction-primary-font-color);

//     .highlight-keywords {
//       background-color: yellow;
//     }
//   }
//   .check-box-click {
//     pointer-events: none;
//     cursor: pointer;
//     top: 2px;
//     margin-right: 8px;
//     position: relative;
//   }
//   input[type=checkbox]:checked {
//     accent-color: #2C86E8;
//   }
// }
</style>